// Component Name:  Report component
// Author: Lavanya S
// Platform: Web
// OS: Windows
// IDE: Visual Studio Code
// Reference: ChargerFilter and customers
// Date:04-06-2025
// Description: This component is to download the report by applying the filters( date range, location,charger).
// Interfaces: Accepts props
// Maintenance History:  1.0 - First Version
import React, { useEffect, useRef, useState } from "react";
import { Card, CardBody, Container, Collapse, Row, Col, Table, UncontrolledTooltip, Label, Input } from "reactstrap";
import Breadcrumb from "../../components/Common/Breadcrumb";
import { Link } from "react-router-dom";
import LKLocationImg from "../../assets/images/LK_Icons/LK_Location Pin.svg";
import LKChargerImg from "../../assets/images/LK_Icons/LK__EV charger_blue.svg";
import LKEventImg from "../../assets/images/LK_Icons/LK_Event.svg";
import CheckBox from "../Utility/CheckBox";
import { loadLocation } from "../../api/utils/loadLocations";
import { connect } from "react-redux";
import { dateRangeData } from "../Dashboard/dbConstants";
import checkedImg from "../../assets/images/auth/LK__Check.svg";
import uncheckedImg from "../../assets/images/auth/LK_white_Uncheck.svg";
import { MONTHS, REPORT_DETAILS } from "../Utility/Constants";
import DateRangePicker from "../Utility/DateRangePicker";
import { ActiveBtn, CancelBtn, InActiveBtn } from "../Utility/Button";
import { downloadReportInPDF } from "../../api/downloadInvoice";
import { resetReportData, warningToast } from "../../store/dbFilter/actions";
import Modal from "react-modal";
import Spinner from "../Utility/Spinner";

const Report = (props) => {
  const { locationIds, chargerToLocationMap, warningToast, resetReportData } = props;
  const breadcrumbItems = [
    { title: "Charger Management System", link: "#" },
    { title: "Report", link: "#" },
  ];
  // Table data
  const [data, setData] = useState(REPORT_DETAILS);

  const [downloadAll, setDownloadAll] = useState(false);
  const [isAcc, setIsAcc] = useState({ dateRangeAcc: false, locationAcc: false, chargerAcc: false });
  const [locationData, setLocationData] = useState([]);
  const [chargerData, setChargerData] = useState([]);

  const [isDateRangeHover, setIsDateRangeHover] = useState(null);
  const [fData, setFData] = useState({ Location: [], charger: [] });

  const [dateRange, setDateRange] = useState([]);

  const [selectedDateRange, setSelectedDateRange] = useState(dateRangeData[6]);

  // dateString will be displayed on the infobar
  const [dateString, setDateString] = useState();

  // start and end date range
  const [startDate, setStartDate] = useState(dateRange[0]);
  const [endDate, setEndDate] = useState(dateRange[1]);
  const [isDownloadLoading, setIsDownloadLoading] = useState(false);
  const dateRef = useRef(null);
  const locationRef = useRef(null);
  const chargerRef = useRef(null);
  const calendarRef = useRef(null);
  const startRef = useRef(null);
  const endRef = useRef(null);
  console.log("dateRange: ", dateRange);

  useEffect(() => {
    Modal.setAppElement("#root");
    setData(REPORT_DETAILS);
    return () => resetReportData();
  }, []);

  useEffect(() => {
    handleReportSelected();
  }, [props?.report]);

  //handle the selected report
  const handleReportSelected = () => {
    if (props?.sharedData?.report === null) {
      const updateData = data?.map((item, index) => {
        return (data[index] = { ...data[index], isSelected: true });
      });
      setData(updateData);
      const allSelected = updateData.every((item) => item.isSelected);
      setDownloadAll(allSelected);
    } else {
      const updateData = data?.map((item, index) => {
        if (item?.value === props?.report?.value) {
          return (data[index] = { ...data[index], isSelected: true });
        } else {
          return (data[index] = { ...data[index], isSelected: false });
        }
      });
      setData(updateData);
      const allSelected = updateData.every((item) => item.isSelected);
      setDownloadAll(allSelected);
    }
  };

  // Auto-update "Select All" checkbox based on individual selections
  useEffect(() => {
    const allSelected = data.every((item) => item.isSelected);
    setDownloadAll(allSelected);
  }, [data]);

  useEffect(() => {
    handleLoadLocations();
  }, [locationIds]);

  // load the images map for each location images
  const handleLoadLocations = async () => {
    let tempLoc = [];
    try {
      const data = await loadLocation(locationIds);
      setLocationData(data);
      // navigated from the dashboard
      if (props?.location !== null) {
        tempLoc = [props?.location?.value];
      } else {
        tempLoc = data.map((loc) => loc.id);
      }
      setFData({ ...fData, Location: tempLoc });
    } catch (e) {
      console.log("Error Images Data: ", e);
    }
  };

  // when ever location is changed, charger details will be updated
  useEffect(() => {
    const loc = fData?.Location;
    let chargersInSelectedLocation = [];
    if (loc?.length > 0) {
      chargersInSelectedLocation = loc?.flatMap((item) => chargerToLocationMap[item] || []);
    }
    setChargerData(chargersInSelectedLocation);
    const tempCharger = chargersInSelectedLocation.map((charger) => charger.id);
    setFData({ ...fData, charger: tempCharger });
  }, [fData?.Location]);

  // to add the checked data in the fData
  const addValue = (value) => {
    setFData((prevState) => {
      const newFData = { ...prevState };

      if (!value) return prevState;

      // Add Location object if it doesn't already exist
      if (value?.Location) {
        const exists = (newFData.Location || []).some((loc) => loc === value.Location);
        if (!exists) {
          newFData.Location = [...(newFData.Location || []), value.Location].sort((a, b) => {
            if (!a?.name) return 1;
            if (!b?.name) return -1;
            return a.name.localeCompare(b.name);
          });
        }
      }

      // Add charger object if it doesn't already exist
      if (value?.charger) {
        const exists = (newFData.charger || []).some((ch) => ch === value.charger);
        if (!exists) {
          newFData.charger = [...(newFData.charger || []), value.charger].sort((a, b) => {
            if (!a?.name) return 1;
            if (!b?.name) return -1;
            return a.name.localeCompare(b.name);
          });
        }
      }

      return newFData;
    });
  };

  // to handle remove location, when a location is removed, remove the dependency charger as well
  const removeValue = (value) => {
    setFData((prevState) => {
      if (!value) return prevState;
      const newFData = { ...prevState };

      // 1. Remove the location
      if (value.Location) {
        newFData.Location = (newFData.Location || []).filter((loc) => loc !== value.Location);
      }

      // 2. Recalculate charger list based on remaining locations
      const remainingLocations = newFData.Location || [];
      const chargersToKeep = remainingLocations.flatMap((loc) => chargerToLocationMap[loc] || []);

      // 3. filter all the existing charger based on the updated location data
      const uniqueChargers = chargersToKeep?.filter((item) => fData?.charger?.some((ch) => ch === item));

      newFData.charger = uniqueChargers;

      return newFData;
    });
  };

  // to independently remove charger checked(when user uncheck charger)
  const removeChargerValue = (value) => {
    setFData((prevState) => {
      if (!value) return prevState;
      const newFData = { ...prevState };
      newFData.charger = (newFData.charger || []).filter((ch) => ch !== value.charger);
      return newFData;
    });
  };

  // to calc the date string for the Infobar display
  useEffect(() => {
    let dateStr = "";
    const dateRangeLocal = props?.dateRange ? props?.dateRange?.value : selectedDateRange?.value;
    switch (dateRangeLocal) {
      case "today":
        dateStr = "Today";
        break;
      case "yesterday":
        dateStr = "Yesterday";
        break;
      default:
        const startDate = new Date(dateRange[0]) || "";
        const endDate = new Date(dateRange[1]) || "";

        if (startDate && endDate) {
          const firstDayOfMonth = new Date("2024-01-01");
          const today = new Date();
          firstDayOfMonth.setHours(0, 0, 0, 0);
          today.setHours(23, 59, 59, 999);
          // Format the start and end dates
          const startString = `${[startDate?.getDate()] || ""}-${MONTHS[startDate?.getMonth()] || ""}-${startDate?.getFullYear() || ""}`;
          const endString = `${[endDate?.getDate()] || ""}-${MONTHS[endDate?.getMonth()] || ""}-${endDate?.getFullYear() || ""}`;
          if (startDate?.getTime() === firstDayOfMonth?.getTime() && endDate?.getTime() === today?.getTime()) {
            dateStr = `Till Date - ${endString}`;
          } else {
            dateStr = `${startString} to ${endString}`;
          }
        } else {
          dateStr = "Invalid date range";
        }
        break;
    }
    setDateString(dateStr);
  }, [dateRange]);

  // Based on the date range type selected by the user,
  // start date and end date will be calculated
  const calcDateRange = (dateRangeType) => {
    const today = new Date();
    let start = null;
    let end = null;
    setEndDate(null);
    setStartDate(null);
    console.log("dateRangeType: ", dateRangeType);

    switch (dateRangeType) {
      case "today":
        start = new Date(today);
        end = new Date(today);
        break;

      case "yesterday":
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        start = new Date(yesterday);

        const yesterdayEnd = new Date(yesterday);
        end = yesterdayEnd;
        break;

      case "day7":
        const last7DaysStart = new Date(today);
        last7DaysStart.setDate(today.getDate() - 6);
        start = last7DaysStart;

        end = new Date(today);
        break;

      case "day30":
        const last30DaysStart = new Date(today);
        last30DaysStart.setDate(today.getDate() - 29);
        start = last30DaysStart;

        end = new Date(today);
        break;

      case "thisMonth":
        const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        start = firstDayOfMonth;

        end = new Date(today);
        break;

      case "lastMonth":
        const firstDayOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        const lastDayOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);

        start = firstDayOfLastMonth;
        end = lastDayOfLastMonth;
        break;

      default:
        break;
    }

    handleDateRange(start, end);
  };

  // update the selected daterange
  const handleDateRange = (startDate, endDate) => {
    if (isNaN(startDate?.getTime())) {
      startDate = new Date("2024-01-01");
    }
    if (isNaN(endDate?.getTime())) {
      endDate = new Date();
    }
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);
    setDateRange([startDate, endDate]);
  };

  // reset all filter
  const resetFilters = () => {
    setIsAcc({
      dateRangeAcc: false,
      locationAcc: false,
      chargerAcc: false,
    });
    setFData({ Location: locationData.map((loc) => loc.id), charger: [] });
    setSelectedDateRange(dateRangeData[6]);
    const today = new Date();
    const firstDayOfMonth = new Date("2024-01-01");
    handleDateRange(firstDayOfMonth, today);
  };

  // to handle click outside the dropdown
  const handleClickOutside = (event) => {
    const startInstance = startRef.current ? startRef.current.flatpickr : null;
    const endInstance = endRef.current ? endRef.current.flatpickr : null;

    if (
      dateRef.current &&
      !dateRef.current.contains(event.target) &&
      locationRef.current &&
      !locationRef.current.contains(event.target) &&
      chargerRef.current &&
      !chargerRef.current.contains(event.target)
    ) {
      if (calendarRef?.current) {
        if (
          !calendarRef.current.contains(event.target) &&
          startInstance &&
          startInstance.calendarContainer &&
          !startInstance.calendarContainer?.contains(event.target) &&
          endInstance &&
          endInstance.calendarContainer &&
          !endInstance.calendarContainer?.contains(event.target)
        ) {
          setIsAcc({
            dateRangeAcc: false,
            locationAcc: false,
            chargerAcc: false,
          });
        }
      } else {
        setIsAcc({
          dateRangeAcc: false,
          locationAcc: false,
          chargerAcc: false,
        });
      }
    }
  };

  // Close dropdown when click outside
  // to set the date range on component mount
  useEffect(() => {
    if (props?.dateRange) {
      const { value, name, dateRange } = props?.dateRange;
      setSelectedDateRange({ value, name });
      if (value !== "dateRange") {
        calcDateRange(value);
      } else {
        handleDateRange(new Date(dateRange[0]), new Date(dateRange[1]));
      }
    } else {
      const today = new Date();
      const firstDayOfMonth = new Date("2024-01-01");
      handleDateRange(firstDayOfMonth, today);
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Select or deselect all checkboxes
  const selectAll = () => {
    const updatedData = data.map((item) => ({
      ...item,
      isSelected: !downloadAll,
    }));
    setData(updatedData);
    setDownloadAll(!downloadAll);
  };

  // Render a single checkbox
  const selectRow = (item, isClick = true) => {
    const { isSelected } = item;
    return (
      <img
        src={isSelected ? checkedImg : uncheckedImg}
        alt="checkedImg"
        onClick={() => {
          if (isClick) {
            item?.value !== "rfid" && setData((prevData) => prevData.map((d) => (d.value === item.value ? { ...d, isSelected: !d.isSelected } : d)));
          }
        }}
        style={{ width: "16px", height: "16px", cursor: item?.value !== "rfid" ? "pointer" : "not-allowed" }}
      />
    );
  };

  const handleDownload = async () => {
    const reportTitle = data?.filter((item) => item.isSelected).map((item) => item.value);
    const chargerIds = fData.charger;
    const locationIds = fData.Location;
    if (chargerIds.length === 0 || locationIds.length === 0) {
      warningToast({ title: "Validation", message: "Select location/charger to generate the report" });
      return;
    }
    if (reportTitle?.length === 0) {
      warningToast({ title: "Validation", message: "Select the reports to be downloaded" });
      return;
    }
    try {
      setIsDownloadLoading(true);
      // console.log("Charger Ids: ",chargerIds.join(", "), );
      // console.log("Location Ids: ",locationIds.join(", "));
      
      const data = await downloadReportInPDF({ dateRange, chargerIds: fData.charger, locationIds: fData.Location, reportTitle });
    } catch (e) {
      console.log("Error in downloading report", e);
    } finally {
      setIsDownloadLoading(false);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Reports" breadcrumbItems={breadcrumbItems} />
          <Card>
            <CardBody>
              {/* to show the spinner while the report is being downloaded */}
              <Modal isOpen={isDownloadLoading} contentLabel="spinner Modal" style={styles.modalStyle}>
                <Spinner />
              </Modal>
              <h6>Filters</h6>
              <Row>
                {/* Date Range accordian */}
                <Col lg={3}>
                  <div className="categories-group-card" style={{ border: "1px solid #EFEFEF" }}>
                    <Link
                      to="#"
                      className={isAcc.dateRangeAcc ? "categories-group-list accordian-bg-products" : "categories-group-list"}
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsAcc((prevState) => ({
                          ...prevState,
                          dateRangeAcc: !prevState.dateRangeAcc,
                        }));
                      }}
                    >
                      <img src={LKEventImg} alt="connectorsImg" style={{ width: "16px", height: "16px", marginRight: "10px" }} /> Date Range
                      <i
                        style={{ color: "#005C8E" }}
                        className={isAcc.dateRangeAcc === true ? "mdi mdi-minus float-right accor-minus-icon" : "mdi mdi-plus float-right accor-plus-icon"}
                      ></i>
                    </Link>
                    <div style={{ position: "relative" }}>
                      <div style={styles.dropdownStyle}>
                        <Collapse isOpen={isAcc.dateRangeAcc} id="collapseTwo">
                          <div>
                            <ul ref={dateRef} className="list-unstyled categories-list mb-0" style={{ maxHeight: "400px", overflowY: "auto" }}>
                              {dateRangeData.map((item, index) => (
                                <div
                                  className="form-check py-2"
                                  style={{
                                    backgroundColor: item?.value === selectedDateRange?.value ? "#005C8E" : isDateRangeHover === index && "#A2A2A2",
                                    color: item?.value === selectedDateRange?.value ? "#FFFFFF" : isDateRangeHover === index && "#EEEEEE",
                                  }}
                                  key={item.value}
                                  onMouseOver={() => setIsDateRangeHover(index)}
                                  onMouseLeave={() => setIsDateRangeHover(null)}
                                  onClick={() => {
                                    setSelectedDateRange(item);
                                    calcDateRange(item?.value);
                                  }}
                                >
                                  <p className="m-0" style={{ cursor: "pointer" }}>
                                    {item?.name}
                                  </p>
                                </div>
                              ))}
                            </ul>
                            {selectedDateRange?.value === "dateRange" && (
                              <div
                                ref={calendarRef}
                                style={{ display: "flex", flexDirection: "row", justifyContent: "end", alignItems: "center", gap: "10px", marginBottom: "10px" }}
                              >
                                <DateRangePicker
                                  startDate={startDate}
                                  endDate={endDate}
                                  startRef={startRef}
                                  endRef={endRef}
                                  styleData={{ height: "40px", width: "120px" }}
                                  onChangeStart={(date) => {
                                    setStartDate(date);
                                    if (endDate && endDate < date) {
                                      setEndDate(null);
                                    }
                                    handleDateRange(date, endDate);
                                  }}
                                  onChangeEnd={(date) => {
                                    setEndDate(date);
                                    handleDateRange(startDate, date);
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        </Collapse>
                      </div>
                    </div>
                  </div>
                </Col>

                {/* Location accordian */}
                <Col lg={3}>
                  <div className="categories-group-card" style={{ border: "1px solid #EFEFEF" }}>
                    <Link
                      to="#"
                      className={isAcc.locationAcc ? "categories-group-list accordian-bg-products" : "categories-group-list"}
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsAcc((prevState) => ({
                          ...prevState,
                          locationAcc: !prevState.locationAcc,
                        }));
                      }}
                    >
                      <img src={LKLocationImg} alt="connectorsImg" style={{ width: "16px", height: "16px", marginRight: "10px" }} /> Location
                      <i
                        style={{ color: "#005C8E" }}
                        className={isAcc.locationAcc === true ? "mdi mdi-minus float-right accor-minus-icon" : "mdi mdi-plus float-right accor-plus-icon"}
                      ></i>
                    </Link>

                    <div style={{ position: "relative" }}>
                      <div style={styles.dropdownStyle}>
                        <Collapse isOpen={isAcc.locationAcc} id="collapseTwo">
                          <div>
                            <ul ref={locationRef} className="list-unstyled categories-list mb-0" style={{ maxHeight: "400px", overflowY: "auto" }}>
                              <div className="form-check">
                                <CheckBox
                                  label={"All"}
                                  checked={locationData.length > 0 && locationData.every((loc) => fData?.Location?.includes(loc.id))}
                                  checkedData={(isNowChecked) => {
                                    setFData({
                                      ...fData,
                                      Location: isNowChecked ? locationData.map((loc) => loc.id) : [],
                                    });
                                  }}
                                />
                              </div>
                              {locationData.map((location) => (
                                <div className="form-check mb-1" key={location.id}>
                                  <CheckBox
                                    label={location.name}
                                    checked={fData?.Location?.includes(location.id)}
                                    checkedData={(isNowChecked) => {
                                      isNowChecked ? addValue({ Location: location.id }) : removeValue({ Location: location.id });
                                    }}
                                  />
                                </div>
                              ))}
                            </ul>
                          </div>
                        </Collapse>
                      </div>
                    </div>
                  </div>
                </Col>

                {/* Charger accordian */}
                <Col lg={3}>
                  <div className="categories-group-card" style={{ border: "1px solid #EFEFEF" }}>
                    <Link
                      to="#"
                      className={isAcc.chargerAcc ? "categories-group-list accordian-bg-products" : "categories-group-list"}
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsAcc((prevState) => ({
                          ...prevState,
                          chargerAcc: !prevState.chargerAcc,
                        }));
                      }}
                    >
                      <img src={LKChargerImg} alt="chargerImg" style={{ width: "16px", height: "16px", marginRight: "10px" }} /> Charger
                      <i
                        style={{ color: "#005C8E" }}
                        className={isAcc.chargerAcc === true ? "mdi mdi-minus float-right accor-minus-icon" : "mdi mdi-plus float-right accor-plus-icon"}
                      ></i>
                    </Link>
                    <div style={{ position: "relative" }}>
                      <div style={styles.dropdownStyle}>
                        <Collapse isOpen={isAcc.chargerAcc} id="collapseTwo">
                          <div>
                            <ul ref={chargerRef} className="list-unstyled categories-list mb-0" style={{ maxHeight: "400px", overflowY: "auto" }}>
                              {fData?.Location?.length === 0 ? (
                                <p className="mt-1 d-flex justify-content-center">Please Select Location</p>
                              ) : fData?.Location?.length > 0 && chargerData?.length === 0 ? (
                                <p className="mt-1 d-flex justify-content-center">No Charger in selected location</p>
                              ) : (
                                <>
                                  <div className="form-check">
                                    <CheckBox
                                      label={"All"}
                                      checked={chargerData.length > 0 && chargerData.every((char) => fData?.charger?.includes(char.id))}
                                      checkedData={(isNowChecked) => {
                                        setFData({
                                          ...fData,
                                          charger: isNowChecked ? chargerData.map((char) => char.id) : [],
                                        });
                                      }}
                                    />
                                  </div>
                                  {chargerData.map((charger) => (
                                    <div className="form-check mb-1" key={charger?.id}>
                                      <CheckBox
                                        label={charger?.name}
                                        checked={fData?.charger?.includes(charger.id)}
                                        checkedData={(isNowChecked) => {
                                          isNowChecked ? addValue({ charger: charger?.id }) : removeChargerValue({ charger: charger?.id });
                                        }}
                                      />
                                    </div>
                                  ))}
                                </>
                              )}
                            </ul>
                          </div>
                        </Collapse>
                      </div>
                    </div>
                  </div>
                </Col>

                {/* Clear option */}
                <CancelBtn name={"Clear"} handleClick={resetFilters} />
              </Row>
              {/* to show the selected data */}
              <Row className="mt-4 ml-1 d-flex" style={{ gap: "12px" }}>
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ padding: "12px", gap: "5px", border: "2px solid #EFEFEF", borderRadius: "16px", lineHeight: "0" }}
                >
                  <span>
                    <b>Date:</b> {dateString}
                  </span>
                </div>
                {/* TO DISPLAY THE SELECTED DATA, THEN SELECTED DATA TO BE STORED IN THE FORM OF {id,name} */}
                {/* 
                {fData?.Location?.length > 0 && (
                  <div className="d-flex align-items-center flex-wrap" style={{ gap: "5px" }}>
                    <b>Locations:</b>
                    {fData?.Location?.map((item, index) => {
                      return (
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{ padding: "8px", gap: "5px", border: "2px solid #EFEFEF", borderRadius: "16px", lineHeight: "0" }}
                        >
                          <span>{item?.name}</span>
                          <img
                            src={LKCloseImg}
                            alt="closeImg"
                            style={{ width: "12px", height: "12px", cursor: "pointer" }}
                            onClick={() => removeValue({ Location: { id: item.id, name: item.name } })}
                          />
                        </div>
                      );
                    })}
                  </div>
                )}

                {fData?.charger?.length > 0 && (
                  <div className="d-flex align-items-center flex-wrap" style={{ gap: "5px" }}>
                    <b>Chargers:</b>
                    {fData?.charger?.map((item, index) => {
                      return (
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{ padding: "8px", gap: "5px", border: "2px solid #EFEFEF", borderRadius: "16px", lineHeight: "0" }}
                        >
                          <span>{item?.name}</span>
                          <img
                            src={LKCloseImg}
                            alt="closeImg"
                            style={{ width: "12px", height: "12px", cursor: "pointer" }}
                            onClick={() => removeChargerValue({ charger: { id: item?.id, name: item?.name } })}
                          />
                        </div>
                      );
                    })}
                  </div>
                )} */}
              </Row>
            </CardBody>
          </Card>

          {/* reports table */}
          <Card>
            <CardBody>
              <div className="d-flex justify-content-end mb-3">
                <ActiveBtn name={"Download"} handleClick={handleDownload} />
                <InActiveBtn name={"Mail"} handleClick={() => {}} />
              </div>
              <Table
                className="table-centered datatable dt-responsive nowrap "
                style={{
                  borderCollapse: "collapse",
                  borderSpacing: 0,
                  width: "100%",
                }}
              >
                <thead className="thead-light">
                  <tr>
                    <th style={{ width: "20px" }}>
                      <img src={downloadAll ? checkedImg : uncheckedImg} alt="Select All" onClick={selectAll} style={{ width: "16px", height: "16px", cursor: "pointer" }} />
                    </th>
                    <th>SL NO</th>
                    <th>Reports</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  <tr></tr>

                  {data?.length > 0 &&
                    data?.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{selectRow(item)}</td>
                          <td>{index + 1}</td>
                          <td>{item?.name}</td>
                          <td>
                            <span>{item?.description}</span>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};
const styles = {
  dropdownStyle: {
    position: "absolute",
    top: "100%",
    left: 0,
    zIndex: 999,
    background: "#C1C1C1",
    boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
    maxHeight: "400px",
    overflowY: "auto",
    width: "100%",
  },

  loaderContainer: { height: "250px" },
  modalStyle: {
    overlay: { backgroundColor: "rgba(0, 0, 0, 0.3)" },
    content: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "100%",
      height: "100%",
      padding: "15px",
      borderRadius: "10px",
      backgroundColor: "rgba(0, 0, 0, 0.3)",
    },
  },
};
const mapStateToProps = (state) => ({
  chargerIds: state.ChargerManagement.chargerIds,
  locationIds: state.LocationManagement.locationIds,
  chargerToLocationMap: state?.sharedData?.chargerToLocationMap,
  location: state?.sharedData?.location,
  dateRange: state?.sharedData?.dateRange,
  report: state?.sharedData?.report,
  sharedData: state?.sharedData,
});
const mapDispatchToProps = (dispatch) => ({
  warningToast: (payload) => dispatch(warningToast(payload)),
  resetReportData: () => dispatch(resetReportData()),
});
export default connect(mapStateToProps, mapDispatchToProps)(Report);
